import * as React from "react";
import type { SVGProps } from "react";
const SvgAttatchment02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M17.48 6.072v11.21c0 3.05-2.107 5.518-5.217 5.518-3.051 0-5.063-2.408-5.063-5.519v-12.6A3.473 3.473 0 0 1 10.68 1.2a3.473 3.473 0 0 1 3.482 3.48v12.823a1.74 1.74 0 0 1-3.481 0V6.072"
    />
  </svg>
);
export default SvgAttatchment02;
